import { InjectionToken } from '@angular/core';
import { VendorCofig } from '../interfaces/vendor-config';

export const VENDOR_CONFIG = new InjectionToken<VendorCofig | null>(
  'The configuration of the vendorised broker'
);
